(ns manage.content-configuration-page.context-source.create-modal
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.modal.dialog :refer [form-dialog]]
            [common.modal.view :refer [defmodal]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [manage.content-configuration-page.context-source.view
             :as context-source]
            [manage.content-variant-page.view.entity :refer [cc]]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :refer [$]]))

(spec/def ::cs
  (spec/and string?
            (complement str/blank?)))

(spec/def ::value
  (spec/keys :req-un [::cs]))

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.context-source ::value)))

(def use-bind-control (partial form/use-bind-control :form.context-source))

(def use-error-message (partial form/use-error-message :form.context-source))

(form/register-form {:namespace :form.context-source
                     :initial-value {:cs ""}
                     :validate-form validate-form
                     :submit-event :form.context-source/submit-form})

(rf/reg-event-fx :modal.context-source/open
  (fn [_]
    {:fx [[:dispatch [:form.context-source/init]]
          [:dispatch [:modal/open {:id :add-context-source
                                   :on-close [:form.context-source/destroy]}]]]}))

(rf/reg-event-fx :form.context-source/submit-form
  [validate-form]
  (fn [_ [_ {:keys [cs]}]]
    {:fx [[:dispatch [:manage.content-configuration-page.context-source.db/create cs]]
          [:dispatch [:modal/close {:id :entity.dynamic-data/add-context-source}]]]}))

(def title "Create new context source")

(defmodal add-context-source :add-context-source
  {:sx {".MuiPaper-root" {:overflow-y "visible"}}}
  []
  [form-dialog {:on-submit #(rf/dispatch [:form.context-source/submit])
                :submit-button-label "Add"
                :submit-button-testid "context-source-modal-submit-button"
                :cancel-button-testid "context-source-modal-cancel-button"
                :title title}
   ($ Stack {:spacing 2}
      ($ :p "Create a new context source so that you can use its contexts for your targeting.")
      ($ form-field
         {:label "Create context source"
          :err-msg (use-error-message [:cs])}
         (r/as-element
          [dropdown (merge (use-bind-control [:cs])
                           {:options @(rf/subscribe [:manage.content-configuration-page.context-source.schema/schema-options-filtered-by-adset-type])
                            :data-testid "context-source-modal-select"})]))
      ($ Alert {:severity "info"}
         ($ Stack {:direction "row" :alignItems "center" :spacing 0.5}
            ($ :span "You can later manage all your context sources in")
            ($ Icon {:fontSize "small"} (:entity/icon (context-source/list-cfg cc)))
            ($ :span (:entity/label (context-source/list-cfg cc)) "."))))])

(defmodal configure-context-source? :configure-context-source?
  [{:keys [on-submit]}]
  [form-dialog {:on-submit on-submit
                :submit-button-label "Yes, take me there"
                :cancel-button-label "No"
                :title "Configure context source?"}
   "The context source you created requires additional configuration. Do you want to configure it now?"])
